import Backbone from '@trello/backbone';

export const navigate = (...args) => {
  return Backbone.history.navigate(...args);
};
